import { openModal } from "./modalImage";

const MyImg = ({src, alt = "Image", modal = false, shadow = false, shadowSmall = false}) => {
  return (
    <img className={`col-12${modal ? " pointer" : ""}${shadow ? " img-shadow" : ""}${shadowSmall ? " img-shadow-sm" : ""}`} src={src} alt={alt} onClick={modal ? () => openModal(src, alt) : null} />
  );
}

export default MyImg;